import { Injectable } from '@angular/core';
import * as Constants from '../models/Constants';
import { Global } from '../global/globalApi';
import { HttpClient } from '@angular/common/http';
import { RootScopeService } from './root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsCardService {

  constructor(private http: HttpClient, public rootScope: RootScopeService) { }

  dbMyApppointmentsLoader: boolean = false;
  showDbMyApppointmentsLoaderMsg: boolean = false;
  hasNoDbMyApppointmentsData: boolean = false;
  isDbMyApppointmentsErrorEnabled: boolean = false;
  dbMyApppointmentsloaderTimeoutId: any;
  dashboardMyAppointmentsData: any;
  showLoaderMsgThreshold = Constants.NETWORK_SPEED_TEST.apiThresholdLimitDefaultValue;


  getDashboardMyAppointments(event) {
    if(!this.rootScope.getClientId(this.rootScope.dashboardForm.get('clientNameDash')?.value)){
      return;
    }
    this.dbMyApppointmentsloaderTimeoutId = setTimeout(() => {
      this.showDbMyApppointmentsLoaderMsg = true;
    }, 1 * this.showLoaderMsgThreshold * 1000);
    this.isDbMyApppointmentsErrorEnabled = false;
    this.hasNoDbMyApppointmentsData = false;
    this.dbMyApppointmentsLoader = true;

    let url = `${Global.domainUrl}${Global.dashboardApi.dashboardLeftNavigation}`;
    let body = {
      clientId: event?.value,
      layoutId: Constants.LAYOUT_ID.DashboardMyAppointments
    };
    this.http.post(url, body, { headers: this.rootScope.getCommonHeaders(Constants.apiVersions) }).subscribe({
      next: (res: any) => {
        clearTimeout(this.dbMyApppointmentsloaderTimeoutId);
        this.dbMyApppointmentsLoader = false;
        this.showDbMyApppointmentsLoaderMsg = false;
        this.hasNoDbMyApppointmentsData = false;
        this.isDbMyApppointmentsErrorEnabled = false;
        if (res?.data?.menuList.length > 0) {
          this.dashboardMyAppointmentsData = res?.data?.menuList;
        }
        else {
          this.dashboardMyAppointmentsData = res?.data?.menuList;
          this.isDbMyApppointmentsErrorEnabled = true;
          this.hasNoDbMyApppointmentsData = true;
        }
        ;
        console.log(res);
      },
      error: (err) => {
        //this.captureLogsDb("GET-DASHBOARD-MYAppointments-FAILURE: " + err, Constants.ERROR);
        clearTimeout(this.dbMyApppointmentsloaderTimeoutId);
        this.dbMyApppointmentsLoader = false;
        this.showDbMyApppointmentsLoaderMsg = false;
        this.isDbMyApppointmentsErrorEnabled = true;
        console.log(err);
      }
    })
  }

  /**
   * 
   * @param selectedLink 
   * @param account 
   */
  openSelectedLink(selectedLink: any, account: boolean) {
    this.rootScope.selectedLeftNavBarLink(selectedLink, account);
  }
}
